import {
  ExportOutlined,
  ImportOutlined,
  RedoOutlined,
} from "@ant-design/icons";
import { Tabs } from "antd";
import React from "react";
import { useSearchParams } from "react-router-dom";
import TransformIcon from "../../components/icons/Transform";
import WarehouseListExport from "./WarehouseListExport";
import WarehouseListExportTransfer from "./WarehouseListExportTransfer";
import WarehouseListImport from "./WarehouseListImport";
import WarehouseListTransfer from "./WarehouseListTransfer";
import WarehouseReturn from "./WarehouseReturn";

const WarehouseInEx: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab") || "import";
  const onChange = (key: string) => {
    setSearchParams({ tab: key });
  };

  const items = [
    {
      key: "import",
      label: (
        <span>
          <ImportOutlined style={{ marginRight: 12 }} />
          Danh sách phiếu nhập
        </span>
      ),
      children: <WarehouseListImport />,
    },
    {
      key: "export",
      label: (
        <span>
          <ExportOutlined style={{ marginRight: 12 }} />
          Danh sách phiếu xuất
        </span>
      ),
      children: <WarehouseListExport />,
    },
    {
      key: "transfer",
      label: (
        <span>
          <TransformIcon style={{ marginRight: 12 }} />
          Phiếu luân chuyển kho xuất
        </span>
      ),
      children: <WarehouseListTransfer />,
    },
    {
      key: "export-transfer",
      label: (
        <span>
          <TransformIcon style={{ marginRight: 12 }} />
          Danh sách phiếu xuất luân chuyển
        </span>
      ),
      children: <WarehouseListExportTransfer />,
    },
    {
      key: "return",
      label: (
        <span>
          <RedoOutlined style={{ marginRight: 12 }} />
          Phiếu trả hàng
        </span>
      ),
      children: <WarehouseReturn />,
    },
  ];

  return (
    <Tabs
      defaultActiveKey={tabParam}
      onChange={onChange}
      items={items}
      size="large"
      type="card"
      className="p-4"
    />
  );
};

export default WarehouseInEx;
